import { render } from "./AppVersionInfoR.vue?vue&type=template&id=f651cfa6"
import script from "./AppVersionInfoR.vue?vue&type=script&lang=js"
export * from "./AppVersionInfoR.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__